/**
 * Transaction Column Models
 * Defines the structure for dynamic column configuration from the server
 */

/**
 * Single column definition from server
 */
export interface TransactionColumn {
  key: string; // Field identifier (e.g., 'reference', 'amount', 'status')
  label: string; // Display label (e.g., 'Référence', 'Montant', 'Statut')
  default: boolean; // Whether column is visible by default
  type: string; // Data type: 'string', 'number', 'date', 'status', 'array', 'object'
  sortable: boolean; // Whether column can be sorted
}

/**
 * API response containing column definitions
 */
export interface ColumnResponse {
  columns: TransactionColumn[];
}

/**
 * Request payload for fetching column definitions
 */
export interface ColumnRequestPayload {
  merchant_id: string;
  merchant_user_id: string;
  user_type: 'merchant';
  device_type: 'web';
  token: string;
}

/**
 * Minimal fallback columns (used when API fails after retries)
 * Provides essential columns to prevent UI blocking
 */
export const FALLBACK_COLUMNS: TransactionColumn[] = [
  { key: 'reference', label: 'Référence', default: true, type: 'string', sortable: false },
  { key: 'amount', label: 'Montant', default: true, type: 'number', sortable: true },
  { key: 'status', label: 'Statut', default: true, type: 'status', sortable: true },
  { key: 'date', label: 'Date', default: true, type: 'date', sortable: true },
  { key: 'title', label: 'Titre', default: true, type: 'string', sortable: true },
];
